import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";
import { RequestType } from "../../../shared/Enum";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const editFormCL = async (
  dataForm?: IForm,
  dataUpload?: NewIDataUploadItem[],
  uploadRealization?: NewIDataUploadItem[],
  requestID?: string,
  requestStatusID?: string,
  crrNumber?: string,
  dataUploadSK?: NewIDataUploadItem[]
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(dataUpload || []);
  const realization =
    dataForm?.needRealization == "true"
      ? convertData(uploadRealization || [])
      : [];

  const sk = convertData(dataUploadSK || []);
  const data = HttpService.post(
    ApiService.alesaForm.editFormCorporateLegal,
    JSON.stringify({
      CrrNumber: crrNumber,
      StartDateString: dataForm?.startDatePeriod,
      EndDateString: dataForm?.endDatePeriod,
      RequestDate: dataForm?.requestDate,
      POADate: dataForm?.dateOfPower,
      POAGrantDate: dataForm?.dateGrantOfPower,
      CLNote: dataForm?.clNote,
      LRNote: dataForm?.lrNote,
      BinusianID: dataForm?.binusianID,
      BinusianName: dataForm?.binusianName,
      TitleAgreement: dataForm?.titleAgreement,
      Counterpart: dataForm?.counterPart,
      Signer: `${dataForm?.signer?.binusianIDEmail}#${dataForm?.signer?.name}`,
      NeedSK:
        dataForm?.requestType == RequestType.toId(RequestType.DokumenMaster)
          ? dataForm?.needSK == "true"
          : null,
      NeedRealization:
        dataForm?.requestType == RequestType.toId(RequestType.DokumenMaster)
          ? dataForm?.needRealization == "true"
          : null,
      DocumentTypeID: dataForm?.documentType,
      Area: dataForm?.area,
      DetailArea: dataForm?.address,
      ListDocument: files,
      RequestID: requestID,
      RequestTypeID: dataForm?.requestType,
      Delegatee:
        dataForm?.delegatee != null
          ? `${dataForm?.delegatee?.binusianIDEmail}#${dataForm?.delegatee?.name}`
          : dataForm?.delegatee,
      Substitutor:
        dataForm?.substitutor != null
          ? `${dataForm?.substitutor?.binusianIDEmail}#${dataForm?.substitutor?.name}`
          : dataForm?.substitutor,
      RequestStatusID: requestStatusID,
      ListFileUploadDocumentRealization: realization,
      ListFileUploadDocumentHardCopySK: sk,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const cancelPendingReject = async (
  requestID?: string,
  binusianID?: string,
  comment?: string,
  commentDocument?: NewIDataUploadItem[],
  requestStatusID?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(commentDocument || []);
  const data = HttpService.post(
    ApiService.alesaForm.pendingRejectCancelALESA,
    JSON.stringify({
      RequestID: requestID,
      BinusianID: binusianID,
      Comment: comment,
      ListCommentDocument: files,
      RequestStatusID: requestStatusID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
